import React from 'react'
import {Header} from "../../../header/Header";

export const NotifierApp = () => {
    return (
        <>
            <Header />
            <div className="container">
                <div className="row mt-4 d-flex justify-content-between align-items-center">
                    <div className="col-12 text-center">
                        <h2 style={{fontFamily: 'Segoe UI",Arial,sans-serif', fontWeight: '400'}}>Notifier App</h2>
                        <div style={{width: '50%', height: '4px', backgroundColor: 'lightgreen', marginLeft: 'auto', marginRight: 'auto'}} />
                    </div>
                    <div className="col-12 mt-3">
                        <p>The Zynity Notifier App, also know as Z-News, installs on your personal device for realtime activity of your Executive Team.</p>
                        <br/>
                        <p>To get your copy of the Zynity News app - select the operating system below and follow the guide. <br/>
                            Once the app is installed, open it and log in using your Zynity credentials. You will then be alerted to 'Executive Team' member activity.
                        </p>

                        <div style={{background: 'lightgray', padding: '4px'}}>
                            <b>Windows</b>
                        </div>
                        <p className='mt-2 mx-3'>Guide:</p>
                        <ol className='mx-4'>
                            <li>Uninstall the current version of the Z-News app from you computer.</li>
                            <li>Search for 'Zynity' in the <b>Microsoft Store</b> on your computer, click on the Z-News app. Click on install.</li>
                            <li>Once the download is complete - click Open and log in.</li>
                        </ol>

                        <div style={{background: 'lightgray', padding: '4px'}}>
                            <b>MacOS:</b>
                        </div>
                        <p className='mt-2 mx-3'>Guide:</p>
                        <ol className='mx-4'>
                            <li>Access the iCloud store using your device.</li>
                            <li>Search for "zynity". When "Zynity News" shows in the list, click to install.</li>
                            <li>Follow the instructions/prompts.</li>
                            <li>Open the app and log in.</li>
                        </ol>

                        <div style={{background: 'lightgray', padding: '4px'}}>
                            <b>Android:</b>
                        </div>
                        <p className='mt-2 mx-3'>Guide:</p>
                        <ol className='mx-4'>
                            <li>Access the <b>Android Play</b> store using your mobile device.</li>
                            <li>Search for "zynity". When "Zynity News" shows in the list, click to install.</li>
                            <li>Follow the instructions/prompts.</li>
                            <li>Open the app and log in.</li>
                        </ol>

                        <div style={{background: 'lightgray', padding: '4px'}}>
                            <b>iPhone:</b>
                        </div>
                        <p className='mt-2 mx-3'>Guide:</p>
                        <ol className='mx-4'>
                            <li>Access the <b>iPhone App</b> store using your mobile device.</li>
                            <li>Search for "zynity". When "Zynity News" shows in the list, click to install.</li>
                            <li>Follow the instructions/prompts.</li>
                            <li>Open the app and log in.</li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    )
}
